import { useEffect } from 'react'
import { X, ShoppingCart } from 'lucide-react'
import { useCartStore } from '../../state/cartStore'
import { useCart } from '../../hooks/useCart'
import { CartItemRow } from '../components/CartItemRow'
import { CartSummary } from '../components/CartSummary'
import { EmptyCart } from '../components/EmptyCart'

export function CartDrawer() {
  const open = useCartStore((s) => s.drawerOpen)
  const closeDrawer = useCartStore((s) => s.closeDrawer)
  const { items, totals } = useCart()

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') closeDrawer() }
    window.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [open, closeDrawer])

  return (
    <>
      {/* Overlay */}
      <div
        onClick={closeDrawer}
        className={[
          'fixed inset-0 bg-black/40 z-40 transition-opacity',
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
        ].join(' ')}
      />

      {/* Drawer */}
      <aside
        className={[
          'fixed top-0 right-0 h-full w-full sm:w-[420px] bg-surface shadow-2xl z-50 flex flex-col transition-transform duration-300',
          open ? 'translate-x-0' : 'translate-x-full',
        ].join(' ')}
        aria-hidden={!open}
      >
        <header className="h-16 px-5 border-b border-border flex items-center justify-between shrink-0">
          <div className="flex items-center gap-2 font-semibold text-text">
            <ShoppingCart className="w-5 h-5 text-brand-600" />
            Giỏ hàng ({totals.itemCount})
          </div>
          <button
            onClick={closeDrawer}
            className="w-9 h-9 rounded-full hover:bg-slate-100 flex items-center justify-center transition"
            aria-label="Đóng"
          >
            <X className="w-5 h-5" />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <EmptyCart onClose={closeDrawer} />
          ) : (
            <div className="px-5">
              {items.map((it) => (
                <CartItemRow key={it.id} item={it} compact />
              ))}
            </div>
          )}
        </div>

        {items.length > 0 && (
          <footer className="border-t border-border p-5 shrink-0 bg-slate-50">
            <CartSummary compact onCheckoutClick={closeDrawer} />
          </footer>
        )}
      </aside>
    </>
  )
}
